export const QUADRANT_INTENSITY = "quadrant_intensity"
export const SIMULATION_CURRENT_VALUE_DATA = "simulation_current_value_data"
export const SIMULATION_PREDICTIVE_VALUE_DATA = "simulation_predictive_value_data"
export const VIEW_TYPE_DATA = "view_type_data"